import { __assign } from "tslib";
import React, { useEffect, useState } from "react";
import { View } from 'react-native';
import { PnmacPageBubble, PnmacRadioButton, PnmacRadioButtonGroup, PnmacMediaQuery, PnmacUIButton, PnmacText, PnmacMeta, BannerView } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { UPDATE_LOAN_PREF, addNotesToLamp, trackerDispatcher } from '../../redux/actions/actions.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { textStyle } from "../../v2/theme";
import * as AppEvents from "../../redux/events/events.js";
import { StyleSheet } from 'react-native';
import { useDispatch, useSelector } from "react-redux";
var TrackerHitTypeLID_ENUM = AppEvents.TrackerHitTypeLID_ENUM,
  TrackerActionLID_ENUM = AppEvents.TrackerActionLID_ENUM,
  TrackerCategoryLID_ENUM = AppEvents.TrackerCategoryLID_ENUM,
  UserLanguage_ENUM = AppEvents.UserLanguage_ENUM;
var TaxOptions = function (props) {
  var layout = useSelector(function (store) {
    return store;
  });
  var translations = layout.translations;
  var dispatch = useDispatch();
  var _a = useState(null),
    selectedOption = _a[0],
    setSelectedOptons = _a[1];
  var _b = useState(layout === null || layout === void 0 ? void 0 : layout.selectedLoanPreference),
    loanPreference = _b[0],
    setLoanPreference = _b[1];
  var _c = useState(false),
    confirmFinal = _c[0],
    setConfirmFinal = _c[1];
  var _d = useState(null),
    wisconsinPref = _d[0],
    setWisconsinPref = _d[1];
  var _e = useState(false),
    submitLoading = _e[0],
    setSubmitLoading = _e[1];
  var _f = useState(false),
    optionsEnabled = _f[0],
    setOptionsEnabled = _f[1];
  useEffect(function () {
    getTaxOptionsInfo();
  }, [layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber]);
  useEffect(function () {
    setLoanPreference(layout === null || layout === void 0 ? void 0 : layout.selectedLoanPreference);
    setWisconsinPref(layout === null || layout === void 0 ? void 0 : layout.selectedLoanPreference.find(function (s) {
      return s.preferenceTypeCode == 300089;
    }));
  }, [layout === null || layout === void 0 ? void 0 : layout.selectedLoanPreference]);
  // return 0 or 1 based on the loan property region
  // 0 = 'WI'
  // 1 = 'TX'
  var getLoanTaxOptionType = function () {
    var _a;
    var state_WI = 'WI';
    var state_TX = 'TX';
    var loanPropertyRegion = (_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.propertyRegion;
    if (state_WI === loanPropertyRegion) {
      return 0;
    } else if (state_TX === loanPropertyRegion) {
      return 1;
    }
  };
  //value = 1 or 3
  //1 = Option 1
  //3 = Option 2
  var changeValueExceptWI = function (value) {
    if (value === selectedOption) {
      return; //to prevent mulitple tracker entries.
    }
    var msg = (value === 3 ? 'Option 2' : 'Option 1') + ' selected for tax options';
    dispatch(trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Radio, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, msg, 0));
    setSelectedOptons(value);
  };
  var changeValue = function (value, property) {
    var index = loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.findIndex(function (s) {
      return parseInt(s.preferenceTypeCode) == parseInt(property);
    });
    if (index > -1) {
      loanPreference[index].changed = true;
      loanPreference[index].preferenceCode = value;
    } else {
      var l = __assign({}, loanPreference[0]);
      l.preferenceTypeCode = property;
      l.preferenceCode = value;
      l.active = true;
      l.appId = 23;
      l.changed = true;
      loanPreference.push(l);
    }
    setLoanPreference(loanPreference);
    setSelectedOptons(value);
    dispatch({
      type: UPDATE_LOAN_PREF,
      selectedLoanPreference: loanPreference
    });
  };
  var renderBannerView = function (text) {
    return /*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(BannerView.Text, null, text));
  };
  var getTaxOptionsInfo = function () {
    var type = getLoanTaxOptionType();
    if (type === 0) {
      //wisconsin info
      fetch("".concat(layout.pennyHomeUrl, "api/loan/wisconsin_tax_info"), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        }
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        setOptionsEnabled(data.optionsEnabled || false);
      }).catch(function (err) {
        setOptionsEnabled(false);
      });
    }
    if (type === 1) {
      // tax info
      fetch("".concat(layout.pennyHomeUrl, "api/loan/get_selected_tax_options?loanId=").concat(layout.selectedLoanNumber), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        }
      }).then(function (res) {
        return res.json();
      }).then(function (selectionData) {
        setSelectedOptons(selectionData);
        fetch("".concat(layout.pennyHomeUrl, "api/loan/tax_options_info"), {
          method: 'GET',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(layout.token)
          }
        }).then(function (res) {
          return res.json();
        }).then(function (data) {
          setOptionsEnabled(data.optionsEnabled || false);
        }).catch(function (err) {
          setOptionsEnabled(false);
        });
      }).catch(function (err) {
        setOptionsEnabled(false);
      });
    }
  };
  var submitTaxOptions = function (callback) {
    var loanPreference = layout.loanPreference,
      selectedLoanNumber = layout.selectedLoanNumber,
      mobile = layout.mobile;
    if (propertyType === 0) {
      // wisconsin
      var currentPlatform = mobile ? "Mobile" : "Web";
      dispatch(trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "WI Tax Option Change button clicked ".concat(currentPlatform), 0));
      if (parseInt(selectedLoanNumber) > 0) {
        loanPreference.forEach(function (s) {
          return s.loanId = selectedLoanNumber;
        });
        fetch("".concat(layout.pennyHomeUrl, "api/loan/update_loan_preferences"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(layout.token)
          },
          body: JSON.stringify(loanPreference)
        }).then(function (res) {
          return res.json();
        }).then(function (data) {
          callback(data ? true : false);
        }).catch(function (err) {
          return callback(false);
        });
      }
    } else {
      //tax info
      if (selectedOption === null) {
        return;
      }
      fetch("".concat(layout.pennyHomeUrl, "api/loan/set_selected_tax_options?loanId=").concat(selectedLoanNumber, "&yearEndTaxOption=").concat(selectedOption), {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        }
      }).then(function (data) {
        if (data) {
          var message = "updated Tax Options to " + (selectedOption === 3 ? 'Option 2' : 'Option 1');
          dispatch(addNotesToLamp(selectedLoanNumber, 1000173, message));
        }
        callback(data ? true : false);
      }).catch(function (err) {
        callback(false);
      });
    }
  };
  var propertyType = getLoanTaxOptionType();
  var messageWI = translations.DisplayMessageOne + translations.DisplayMessageTwo + translations.DisplayMessageThree;
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        width: "100%",
        padding: layout.mobile ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacPageBubble, {
      accessibilityRole: "header",
      ariaLevel: "1",
      text: translations.TaxOptionsTitle,
      containerStyles: {
        marginLeft: 10
      }
    }), /*#__PURE__*/React.createElement(PnmacMeta, {
      title: translations.TaxOptionsTitle
    }), propertyType === 0 ? renderBannerView(messageWI) : propertyType === 1 ? renderBannerView(translations.BannerMessageFor_TX) : null, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewParentContainer
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "column",
        justifyContent: "center",
        width: matches.small ? "100%" : "60%"
      }
    }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
      onClick: function () {
        return setConfirmFinal(false);
      },
      message: translations.SuccessfullyUpdatedMessage
    }) : null, propertyType === 0 ? /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.containerStyles
    }, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
      onValueChange: function (value) {
        return changeValue(value, 300089);
      },
      value: selectedOption || (wisconsinPref ? wisconsinPref.preferenceCode : 0),
      style: {
        flexBasis: '20%',
        flexGrow: 1
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.wiscoTax.section
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionTextOne)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        paddingBottom: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.SelectOne)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 300090
    }))), /*#__PURE__*/React.createElement(View, {
      style: styles.wiscoTax.section
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionTextTwo)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 300091
    }))), /*#__PURE__*/React.createElement(View, {
      style: styles.wiscoTax.section
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionTextThree)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 300092
    }))), /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, styles.wiscoTax.section), {
        border: "transparent"
      })
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionTextFour)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 300378
    }))))) : propertyType === 1 ? /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.containerStyles
    }, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
      onValueChange: function (value) {
        return changeValueExceptWI(value);
      },
      value: selectedOption,
      style: {
        flexBasis: '20%',
        flexGrow: 1
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: 70,
        alignSelf: 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.SelectOne)), /*#__PURE__*/React.createElement(View, {
      style: styles.wiscoTax.section
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionOne_TX)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 1
    }))), /*#__PURE__*/React.createElement(View, {
      style: styles.wiscoTax.section
    }, /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.viewWidthStyle
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.OptionTwo_TX)), /*#__PURE__*/React.createElement(View, {
      style: stylesLocal.radioButtonStyle
    }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
      disabled: !optionsEnabled,
      value: 3
    }))))) : null, optionsEnabled ? /*#__PURE__*/React.createElement(View, {
      style: styles.accountSettings.buttonContainer
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      idTag7: 'lblSubmitButtonPnmacText',
      nativeID: "btnSubmitButtonPnmacText",
      name: "SubmitButtonPnmacText",
      testId: "SubmitButtonPnmacText",
      style: {
        width: matches.small ? "100%" : "25%",
        marginTop: layout.mobile ? 10 : 25,
        marginBottom: matches.small ? 20 : 0,
        alignSelf: 'center'
      },
      disabled: layout.pennyWise || selectedOption === null,
      loading: submitLoading,
      mode: "contained",
      testID: "SubmitButtonPnmacText",
      onPress: function () {
        setSubmitLoading(true);
        submitTaxOptions(function (value) {
          setConfirmFinal(value);
          setSubmitLoading(false);
        });
      }
    }, translations.Change)) : null)));
  });
};
export default TaxOptions;
var stylesLocal = StyleSheet.create({
  containerStyles: {
    backgroundColor: "#FFF",
    padding: 25,
    marginBottom: 20,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid #e9e9e9",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
    elevation: 1
  },
  radioButtonStyle: {
    flexDirection: "column",
    alignItems: "center",
    fontSize: 12,
    alignSelf: "flex-start",
    width: 70
  },
  viewWidthStyle: {
    width: '75%'
  },
  viewParentContainer: {
    justifyContent: "center",
    alignItems: 'center'
  }
});